import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../store';

export default function StaffRoute() {
  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);
  const hydrated = useAuthStore((state) => state.hydrated);
  const activePortal = useAuthStore((state) => state.activePortal);

  if (!hydrated) {
    return (
      <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center">
        <div className="text-sm text-gray-500">Chargement...</div>
      </div>
    );
  }

  if (!token || !user || activePortal !== 'staff') {
    return <Navigate to="/staff/login" replace />;
  }

  if (!['staff', 'admin', 'superadmin'].includes(user.role)) {
    return <Navigate to="/staff/login" replace />;
  }

  return <Outlet />;
}
